import styled from 'styled-components';

export const DashboardBody = styled.div.attrs({})`
  height: calc(100vh);
  background: ${(props) => props.theme.palette.lightgrey.main};
  display: flex;
  align-items: flex-start;
  overflow: auto;
  justify-content: flex-end;
`;

export const DashboardBodyContent = styled.div.attrs({})`
  margin-top: 56px;
  height: calc(100vh - 56px);
  width: ${(props) => (props.opened ? 'calc(100% - 276px)' : 'calc(100%)')};
  padding: 10px 10px;
  /* border-box para o padding nao somar a altura e criar scroll de pagina */
  box-sizing: border-box;
  /* coluna flex: a tela decide quem estica e quem fica fixo */
  display: flex;
  flex-direction: column;
  overflow: auto;
  transition:
    width 0.3s ease,
    margin-left 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Content = styled.div.attrs({})`
  overflow: hidden;
  width: 100%;
`;
